<template lang="pug">
  .component-backoffice-policy-list.row.column
    base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="false",)
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from './BaseList'


  export default {
    name: 'FederationList',
    components: {
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Federation.vue'),
      }
    },
    created() {
      this.dataLoader()
    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.federations.list(page, resultsPerPage).all((data) => {
          callback(data)
        })
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// FederationList.vue?6a5618b6